module.exports = __webpack_public_path__ + "img/haw.e178e14e.svg";